<template>
  <div>
    <b-modal
      :id="modalId"
      :ref="modalId"
      :title="filmInfo"
      hide-footer
      @show="initTransactions"
      @hide="clearTransactions"
      centered
      no-close-on-esc
      no-close-on-backdrop
      no-fade
      no-stacking
      no-enforce-focus
      size="xl"
    >
      <div>
        <div class="loading" v-if="transactionLoader">
          <div
            class="seatSection p-3 text-center d-flex align-items-center justify-content-center"
          >
            <b-spinner
              small
              variant="dark"
              label="Spinning"
              class="translate-spinner mr-2"
            ></b-spinner>
            <span class="fs-20">Fetching Transactions. Please Wait....</span>
          </div>
        </div>
        <div class="seatSection pos-user-collection-wrapper" v-else>
          <table
            class="swc-report-table pos-show-transaction-table mb-3"
            border="1"
          >
            <thead>
              <tr>
                <th>Customer Name</th>
                <th>Customer Phone</th>
                <th>Channel</th>
                <th>Transaction Date & Time</th>
                <th>Show Booking Code</th>
                <th>Seats</th>
                <th>F&B</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody
              v-for="(user, userIndex) in transactions"
              :key="userIndex"
              class="sph-report"
            >
              <tr>
                <td>{{ user.customer_name | filterNullUndefined }}</td>
                <td>{{ user.customer_mobile | filterNullUndefined }}</td>
                <td>{{ user.bs_source | filterNullUndefined }}</td>
                <td>{{ user.t_booking_date_time | fulldatemonparse }}</td>
                <td>{{ user.sb_booking_code }}</td>
                <td>{{ user.seats }}</td>
                <td
                  class="textShrink"
                  v-b-tooltip.hover
                  :title="user.fnb_items || ''"
                >
                  {{ user.fnb_items || "-" }}
                </td>
                <td>{{ currFormat(user.total_final_amount) }}</td>
              </tr>
            </tbody>
            <tbody v-if="transactions.length == 0">
              <tr>
                <td colspan="13">
                  <h3 v-if="transactions.length == 0" class="ml-3 text-center">
                    {{ "No records found" }}
                  </h3>
                </td>
              </tr>
            </tbody>
          </table>
           <b-pagination
              v-if="transactions.length"
              v-model="currentPage"
              :total-rows="rows"
              @change="onChangePagination($event)"
              :per-page="perPage"
              aria-controls="my-table"
              class="my-3"
            ></b-pagination>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService.js";
import PosService from "@/services/PosService.js";
import _, { groupBy } from "lodash";

export default {
  props: {
    modalId: String,
    ss_id: Number,
    cinema_id: Number,
    showDetails: {
      type: Object,
      default: () => {
        return {
          screen_name: "",
          movie_name: "",
          ss_actual_start_date: "",
          ss_start_show_time: "",
        };
      },
    },
    onHideModal: {
      type: Function,
      default: null,
    },
  },
  components: {},
  data() {
    return {
      transactionLoader: false,
      submitted: false,
      transactions: [],
      perPage: 10,
      currentPage: 1,
      searchValue: "",
      rows: 0,
      EjsData: null,
      selectedvalue: "10",
      viewingnumbers: [],
    };
  },
  computed: {
    filmInfo() {
      console.log("this.showDetails", this.showDetails);
      let movieName = this.showDetails["movie_name"] || "";
      let showDate = this.showDetails["ss_actual_start_date"] || "";
      let showTIme = this.showDetails["ss_start_show_time"] || "";
      return `${movieName} | ${showDate} | ${showTIme}`;
    },
  },
  mounted() {},
  beforeMount() {},
  beforeDestroy() {},
  methods: {
    clearTransactions() {
      this.transactions = [];
    },
    fetchSeatLayout() {},
    initTransactions() {
      setTimeout(() => {
        this.getScheduleWiseTransactions();
      }, 400);
    },
    onSearch: _.debounce(function () {
      this.getScheduleWiseTransactions();
    }, 1.5 * 1000),
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getScheduleWiseTransactions();
      } else {
        this.currentPage = event;
        this.getScheduleWiseTransactions();
      }
    },
    getScheduleWiseTransactions() {
      this.transactions = [];
      let payload = {
        cinema_id: this.cinema_id,
        ss_id: this.ss_id,
        limit: this.perPage,
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        type: 1,
      };

      this.transactionLoader = true;
      PosService.GetScheduleWiseTransactions(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records && data.Records.length > 0) {
            this.transactions = data.Records;
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
              this.selectedvalue = this.perPage;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
          } else if (data.Records && data.Records.length == 0) {
            this.$toasted.show("No Records Found.");
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((err) => {
          console.log("Error:", err);
        })
        .finally(() => {
          setTimeout(() => {
            this.transactionLoader = false;
          }, 800);
        });
    },
  },
};
</script>
<style scoped>
.listed-movie-time-list li.disabled {
  border-color: #d3d3d3;
  color: #fff;
  background: #d3d3d3;
  pointer-events: none;
  cursor: default;
}

.btn_min_width_190 {
  min-width: 190px;
}

.circle {
  border-radius: 50%;
  width: 1px;
  height: 15px;
  padding: 3px 4px;
  background: #fff;
  border: 1px solid #000;
  color: #000;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
}

.al_dropdown button {
  font-size: 0.84rem;
  line-height: 1;
}

.avail {
  color: green;
}

#listed-movie-synopsis .btn-modal-close {
  top: -10px !important;
  right: -21px !important;
}

.no-padding {
  padding: 0px !important;
}

.search-input {
  /* top: 2.5px; */
  /* top: 0; */
  /* height: 55px; */
  /* font-size: 14px; */
  /* position: absolute; */
  /* width: 25%; */
  /*flex: 0 0 35%;*/
  min-width: 200px;
  /* left: 527px; */
}

.search-input .form-control {
  /* height: 45px; */
  height: 45px;
  /* border-radius: 20px; */
  border-radius: 50rem;
  font-size: 14px;
  width: 100%;
}

/* .pos-menus-hidden {
  top: -156px;
  height: 167px;
} */

/* .pos-modal-close {
  top: -11px !important;
    right: -30px !important;
} */

.viewSwap {
  cursor: pointer;
  text-decoration: underline;
}

/*@media (min-width: 992px) {*/

/* .seat_select_modal .modal-lg{*/
/*  max-width: 1030px;*/
/*  background-color: white;*/
/*  } */

/*}*/

.w-150 {
  min-width: 150px;
}

.seat-type {
  padding: 1rem;
  min-width: 200px;
  height: 115px;
  font-weight: bold;
}

#showRateCardPrice .seat-type {
  width: 280px !important;
}

.seat-type.gold {
  background-color: #fcf4d9;
  color: #f2c94c;
}

.seat-type.silver {
  background-color: #efefef;
  color: #a8a8a8;
}

.seat-type .st-name {
  font-weight: bold;
  font-size: 2.5rem;
  border-bottom: 1px solid #bfbfbf;
  line-height: 1;
  margin-bottom: 0.25rem;
  word-break: break-all;
}

#showRateCardPrice .category {
  width: 240px !important;
}

#showRateCardPrice .category .category-name {
  word-break: break-all;
}

.category {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 160px;
  background-color: #efefef;
  color: black;
  text-align: center;
  margin: 1rem;
  border-radius: 0.5rem;
}

.category.disabled {
  background-color: #f9f9f9;
  color: #999999;
}

.category.disabled .mod-btn {
  background-color: #afc8ed;
}

.category .category-name {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.category .category-price {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.category .category-seats {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-top: 1px solid #bfbfbf;
  padding: 0.25rem;
  width: 100%;
  color: black;
  user-select: none;
}

.category .category-seats .mod-btn {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  color: white;
  background-color: #3876d2;
  height: 40px;
  width: 40px;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.4s;
}

.category .category-seats .mod-btn:hover {
  color: #3876d2;
  background-color: white;
}

.category .category-seats .mod-btn:active,
.category .category-seats .mod-btn.active {
  transform: scale(0.8);
}

.category .category-seats .mod-btn.disabled,
.btn-submit-disabled {
  background-color: lightgrey;
  pointer-events: none;
}

.fl.btn-blue {
  font-size: 20px !important;
  padding: 1.5rem 2rem;
}

.currency-symbol {
  position: absolute;
  top: 50%;
  right: 10px;
  font-size: 12px;
  transform: translateY(-50%);
}

.InputAmount {
  padding-right: 3rem !important;
}

.noFnbItem {
  font-size: 13px;
}

.no-fnb-btn {
  background-color: white !important;
  color: red !important;
  border-color: red !important;
}

.status-dot {
  display: inline-block;
  margin-left: 6px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background-color: var(--success);
}

.nfs-17 {
  font-size: 17px !important;
}

.voucher-box {
  height: 114px;
  margin: 22px;
  width: 40px;
  background: lightgray;
  border-radius: 10px;
}

.voucher_btn {
  background-color: var(--blue);
  color: white;
  border: 1px solid transparent;
  border-radius: 12px;
  /* padding: 16px; */
  padding: 8px;
  text-align: center;
  /* margin-bottom: 24px; */
  margin-bottom: 16px;
  line-height: 1.2;
  cursor: pointer;
  transition: border-color 0.5s, transform 0.5s, background-color 0.5s,
    color 0.5s;
  display: flex;
  flex-flow: column nowrap;
  /* height: 125px; */
  height: 80px;
  justify-content: center;
  align-items: center;
}

.voucher_btn:active {
  transform: scale(0.9);
}

.voucher_btn:active,
.voucher_btn.active,
.voucher_btn:hover {
  background-color: white;
  box-shadow: 0px 2px 6px -1px;
  color: var(--blue);
  border-color: var(--blue);
}

.giftcard_input {
  min-height: 175px;
}

.voucher_btn.inactive {
  /* background-color: grey;
  cursor: default;
  pointer-events: none;
  opacity: 0.2; */
  background-color: lightgray;
  cursor: default;
  pointer-events: none;
  opacity: 0.3;
  color: black;
}

.voucher_btn .voucher_btn__name > p {
  font-size: 18px;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* -webkit-line-clamp: 2; */
  -webkit-line-clamp: 1;
  margin-bottom: 0;
}

.voucher_btn .voucher_btn__screen > p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.voucher_btn .voucher_btn__time > p {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.voucher_btn .voucher_btn__details {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.voucher_btn .voucher_btn__name + .voucher_btn__details {
  margin-top: 4px;
}

.voucher_btn .voucher_btn__details > div:nth-last-child(2) {
  max-width: 65%;
}

.voucher_btn .voucher_btn__details > div:nth-child(2) {
  margin-left: 12px;
}

.voucher_btn_row > article.col-6:nth-child(odd) {
  padding-right: 8px;
}

.voucher_btn_row > article.col-6:nth-child(even) {
  padding-right: 8px;
}

.pm_disbaled {
  opacity: 0.5;
  pointer-events: none;
}

.pos_booking_input_material .input-material input:focus + label,
.pos_booking_input_material
  .input-material
  input:not(:placeholder-shown)
  + label,
.pos_booking_input_material
  .input-material
  textarea:not(:placeholder-shown)
  + label,
.pos_booking_input_material
  .input-material-textarea
  textarea:not(:placeholder-shown)
  + label,
.pos_booking_input_material .input-material input.is_active + label {
  left: 36px;
  top: -5px;
  background-color: #fff;
  color: var(--blue);
  font-size: 12px;
}

.pos_booking_input_material .input-material input.is_active {
  color: #495057;
  background-color: #fff;
  /* border-color: #80bdff; */
  outline: 0;
  /* -webkit-box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%); */
  /* box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%); */
}

.pos_booking_input_material .input-material input + label,
.input-material textarea + label,
.input-material-textarea textarea + label {
  top: 18px;
  left: 36px;
}

.word-break {
  word-break: break-all;
}

@media screen and (min-width: 578px) and (max-width: 768px) {
  .img_height {
    height: 20vh;
  }
}

@media screen and (min-width: 769px) and (max-width: 991px) {
  .img_height {
    height: 20vh;
  }
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
  .img_height {
    height: 21vh;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1400px) {
  .img_height {
    height: 20vh;
  }
}

@media screen and (min-width: 1401px) and (max-width: 1600px) {
  .img_height {
    height: 20vh;
  }
}

@media (max-width: 1200px) {
  .pos-movie-listing-wrapper .btn-blue-lg {
    height: 40px !important;
    font-size: 12px;
  }

  .search-input .form-control {
    height: 40px;
  }
}

.normal-seat {
  display: none !important;
}

.seatNumList li {
  height: 35px;
  width: 35px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  border-radius: 50%;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  background-color: #979797;
  transition: transform 0.25s;
}

.seatNumList li.active,
.seatNumList li:hover {
  background-color: #3876d2;
}

/*@media (min-width: 992px) {*/

/* .seat_select_modal .modal-lg{*/
/*  max-width: 1030px;*/
/*  background-color: white;*/
/*  } */

/*}*/

.seatNumList li:active {
  transform: scale(0.85);
}

.seat-type {
  padding: 1rem;
  min-width: 200px;
  height: 115px;
  font-weight: bold;
}

.seat-type.gold {
  background-color: #f9f9f9;
  color: #f2c94c;
}

.seat-type.silver {
  background-color: #efefef;
  color: #a8a8a8;
}

.seat-type .st-name {
  font-weight: bold;
  font-size: 2.5rem;
  border-bottom: 1px solid #bfbfbf;
  margin-bottom: 0.25rem;
  word-break: break-all;
}

.category {
  display: flex;
  flex-direction: column;
  width: 180px;
  height: 160px;
  background-color: #efefef;
  color: black;
  text-align: center;
  margin: 1rem;
  border-radius: 0.5rem;
}

.category.disabled {
  background-color: #f9f9f9;
  color: #999999;
}

.category.disabled .mod-btn {
  background-color: #afc8ed;
}

.category .category-name {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.category .category-price {
  font-size: 1.5rem;
  font-weight: 500;
  height: 53px;
  text-align: center;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.category .category-seats {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-top: 1px solid #bfbfbf;
  padding: 0.25rem;
  width: 100%;
  color: black;
  user-select: none;
}

.category .category-seats .mod-btn {
  font-weight: bold;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  color: white;
  background-color: #3876d2;
  height: 40px;
  width: 40px;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 0.4s;
  user-select: none;
}

.category .category-seats .mod-btn:hover {
  color: #3876d2;
  background-color: white;
}

.category .category-seats .mod-btn:active {
  transform: scale(0.8);
}

.fl.btn-blue {
  font-size: 20px !important;
  padding: 1.5rem 2rem;
}

#specify_seats_modal .seat-type {
  min-width: 292px !important;
}

#specify_seats_modal .category {
  width: 223px !important;
}

#specify_seats_modal .category .category-name {
  line-break: anywhere !important;
}

#specify_seats_modal .btn-modal-close {
  position: absolute;
  top: -7px !important;
  right: -8px !important;
}

.change_screen {
  transform: rotateX(180deg);
}

.pos-seatlayout-rotate {
  transform: scale(1, -1);
}

.pos-seatlayout-rotate-text {
  transform: scale(1, -1);
}

.large {
  transform: scale(1.2);
}

.height_cutsom {
  height: 75px;
}

.seatTypetext {
  width: 100%;
  font-weight: bold;
  font-size: 16px;
  padding: 8px 0px 8px 0px;
  text-align: center;
  letter-spacing: 1px;
  text-decoration: underline;
  /* border-bottom: 1px solid #000; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.wheel_img {
  background-color: grey;
}

.seat_avail_sec span {
  font-size: 16px;
  font-weight: bold;
}

.avail_box {
  border: 0.5px solid #000;
  width: 30px;
  border-radius: 6px;
  background-color: transparent;
}

.block_seat {
  width: 30px;
  border-radius: 6px;
  background-color: transparent;
}

.bg-qfx-unpaid {
  background-color: #0384b4 !important;
}

.mix-blend-mode img {
  mix-blend-mode: hue;
}

.selected_show_time {
  border: none !important;
  background: var(--success) !important;
  color: white !important;
}

.custom_seat_selection_input {
  border: 1px solid grey;
  border-radius: 10px;
  padding: 5px 10px;
  width: 80px;
}

.custom_seat_selection_input:focus {
  border: 1px solid #75a7f0;
}

.custom_hr_seats {
  border-top: 1px solid #f0f0f0;
  margin: 1px auto;
}

.wheelChairWarning {
  font-size: 16px;
  font-weight: 500;
}

.channel-box {
 display: block !important;
  margin-right: 20px;
  text-align: center;
}

.colorNote {
  height: 35px;
  width: 120px;
  border-radius: 5px;
  border: 1px solid;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 17px;
  font-weight: 500;
}

.channelNote {
  margin-inline: 5px;
  font-weight: bold;
  font-size: 18px;
}

.pos-seatlayout table td {
  min-width: 50px;
  max-width: 65px;
  min-height: 50px;
  padding-bottom: 2px;
  transition: 0.2s, transform 0.5s;
}

.seatSection {
  zoom: 0.7;
  max-height: 800px;
  overflow: auto;
  max-width: 100%;
  min-height: 800px;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/ScheduleWiseTransactionsPopup.vue